import React from "react"
import { elements } from "caradvise_shared_components"
export default elements.ModalDialog
